import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta:{
      title:'EUT报餐系统'
    },
    component: Home
  },
  {
    path: '/direct',
    name: 'direct',
    meta:{
      title:'直接用餐'
    },
    component: () => import('../views/direct.vue')
  },
  {
    path: '/giveHand',
    name: 'giveHand',
    meta:{
      title:'EUT报餐系统'
    },
    component: () => import('../views/giveHand.vue')
  },
  {
    path: '/mealStatistics',
    name: 'mealStatistics',
    meta:{
      title:'EUT报餐系统'
    },
    component: () => import('../views/mealStatistics.vue')
  },
  {
    path: '/yishu-search',
    name: 'yishuSearch',
    meta:{
      title:'EUT报餐系统'
    },
    component: () => import('../views/yishu/search.vue')
  },
  {
    path: '/yishu-content',
    name: 'yishuContent',
    meta:{
      title:'EUT报餐系统'
    },
    component: () => import('../views/yishu/content.vue')
  },
  {
    path: '/employee',
    name: 'employee',
    meta:{
      title:'浙江易尤特员工身份认证系统'
    },
    component: () => import('../views/employee/employee.vue')
  },
  {
    path: '/electronic-statistics',
    name: 'electronic-statistics',
    meta:{
      title:'易尤特电子工牌系统后台'
    },
    component: () => import('../views/electronicStatistics/index.vue')
  },
]


const router = new VueRouter({
  mode: process.env.NODE_ENV === "development" ? "hash" : 'history',
  routes
})
// 导航守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title; // 根据路由动态设置标题
  } else {
    document.title = 'EUT报餐系统'; // 默认标题
  }
  next();
});

export default router
